var $allSliders = [];

const navSlide = () => {
    const burger = document.querySelector('.burger');
    const nav = document.querySelector('.nav-links-wrap');
    const navLinks = document.querySelectorAll('.nav-links li');

    burger.addEventListener('click', () => {
        //toggle Nav
        nav.classList.toggle('nav-active');

        navLinks.forEach((link, index) => {
            link.style.animation = `navLinkFade 1 ease forwards ${index / 7 + 2}s`;
        });
        //burger animation
        burger.classList.toggle('toggle')
    });
}

if ($('.burger').length) {
    navSlide();
}
if ($('.slider').length) {
    const mainPageSliders = $('.slider').slick({
        lazyLoad: 'progressive',
        arrows: true,
        infinite: false,
        variableWidth: false,
        slidesToShow: 3,
        slidesToScroll: 3,
        autoplay: true,
        autoplaySpeed: 8000,

        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
            // You can unslick at a given breakpoint now by adding:
            // settings: "unslick"
            // instead of a settings object
        ]
    });
    $allSliders.push($('.slider'));

    let timeout1 = null;
    let timeout2 = null;

    $('.tab_main').on('click', ' .js-main-menu-tab', function (e) {
        e.preventDefault();
        if (timeout1 !== null) {
            clearTimeout(timeout1);
        }
        if (timeout2 !== null) {
            clearTimeout(timeout2);
        }

        $('.tab_main .js-main-menu-tab').removeClass('active');
        $(this).addClass('active');

        const target = $($(this).attr('href')),
            targetList = target ? target.find('.slick-list').first() : null,
            targetTrack = target ? target.find('.slick-track').first() : null;

        target.closest('.tab-content').find(' .tab-pane').removeClass('show');

        $(this).closest('.tab_main').find(' + .load-tab-spinner').append('<div class="spinner-border spinner-color"></div>');
        targetTrack && targetTrack.addClass('d-none');

        timeout1 = setTimeout(() => {
            timeout1 = null;
            target.closest('.tab-content').find(' .tab-pane').removeClass('active');
            target.addClass('active');

            targetTrack && targetTrack.removeClass('d-none');

            target.find('.slick-slider').first().slick('refresh');

            $(this).closest('.tab_main').find(' + .load-tab-spinner').empty();

            timeout2 = setTimeout(() => {
                timeout2 = null;
                target.addClass('show');
            }, 1);
        }, 150);
    });
}
if ($('.sliderdish').length) {
    $('.sliderdish').slick({
        arrows: false,
        infinite: true,
        swipe: false,
        variableWidth: false,
        slidesToScroll: 1,
        slidesToShow: 1,
        autoplay: false,
        fade: true,
        asNavFor: '.sliderdown',
        /*responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    infinite: true,
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    infinite: true,
                }
            },
            {
                breakpoint: 576,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }]*/
    });
    $allSliders.push($('.sliderdish'));
}
if ($('.sliderdown').length) {
    $('.sliderdown').slick({
        arrows: false,
        infinite: true,
        variableWidth: false,
        slidesToScroll: 1,
        slidesToShow: 3,
        autoplay: false,
        asNavFor: '.sliderdish',
        focusOnSelect: true,
    });
    $allSliders.push($('.sliderdown'));
}

// При ресайзе slick не всегда правильно обновляет ширину
let windowW = $(window).width();
let windowH = $(window).height();
setInterval(function () {
    if (windowW !== $(window).width() || windowH !== $(window).height()) {
        windowW = $(window).width();
        windowH = $(window).height();

        for (let $slider of $allSliders) {
            $slider.slick("refresh");
        }

        /*setTimeout(function () {
            textSlidersCardsMaxFullWidth();
        }, 100);*/
    }
}, 200);

/*setTimeout(function () {
    textSlidersCardsMaxFullWidth();
}, 100);*/
/*function textSlidersCardsMaxFullWidth() {
    $(".card-slider .slider-text4 span:last-child").each(function () {
        let $container = $(this).closest(".slider-text4")
        let $phantom = $container.find("span:first-child");

        if($phantom.outerWidth() > $container.width()) {
            let ratio = $container.width() / $phantom.outerWidth();
            $(this).css("font-size", Math.floor(20 * ratio) + "px");
        } else {
            $(this).css("font-size", '');
        }
    });
}*/

document.addEventListener('keydown', function (e) {
    if (e.keyCode == 119) { // F8
        debugger;
    }
}, {
    capture: true
});

let timeouts = {};

class IdleActivityHelper {
    static timeouts = {};
    uniqId;
    timeout;
    idleCallback;

    constructor(uniqId, timeout, idleCallback) {
        this.uniqId = uniqId;
        this.timeout = timeout
        this.idleCallback = idleCallback
    }

    resetTimer = () => {
        if (this.uniqId in timeouts && timeouts[this.uniqId]) {
            clearTimeout(timeouts[this.uniqId]);
        }
        timeouts[this.uniqId] = setTimeout(this.idleCallback, this.timeout);
    }

    run = () => {

        window.addEventListener('load', this.resetTimer, true);
        window.addEventListener('mousemove', this.resetTimer, true);
        window.addEventListener('mousedown', this.resetTimer, true);
        window.addEventListener('touchstart', this.resetTimer, true);
        window.addEventListener('touchmove', this.resetTimer, true);
        window.addEventListener('click', this.resetTimer, true);
        window.addEventListener('keydown', this.resetTimer, true);
        window.addEventListener('scroll', this.resetTimer, true);
    }
}

if ($('.js-main-menu-tab').length) {

    const tabsLinks = document.querySelectorAll('.tab_main > .nav > .nav-item > .nav-link');
    const tabsCount = tabsLinks.length - 1;

    if (tabsCount > 1) {

        const tabsIdleActivityHelper = new IdleActivityHelper('tabs-clicker', 50000, () => {
            let nextTab = 0;
            tabsLinks.forEach((tabLink, index) => {
                if (tabLink.classList.contains('active')) {
                    nextTab = index < tabsCount ? index + 1 : 0;
                }
            })

            $(tabsLinks).eq(nextTab).trigger('click')
            tabsIdleActivityHelper.resetTimer()
        });

        tabsIdleActivityHelper.run();
    }
}

if (location.pathname.split('/').length > 6) {
    const backToRestaurantIdleActivityHelper = new IdleActivityHelper(
        'back-to-restaurant',
        180000,
        () => {
            location.href = location.pathname.split('/').slice(0, 6).join('/')
        }
    );

    backToRestaurantIdleActivityHelper.run();
}
